window.addEventListener('DOMContentLoaded', () => {
  // Set up a MutationObserver to watch for the addition of the shadowRoot element
  const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const shadowHost = document.querySelector('form-embed#app-embed');

        if (shadowHost && shadowHost.shadowRoot) {
          const shadowRoot = shadowHost.shadowRoot;
          const cssFilePath = document.body.getAttribute('data-shopify-forms-asset');

          if (cssFilePath) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssFilePath;

            shadowRoot.appendChild(link);
          } else {
            console.error('Forms CSS file path not found in the <body> data attribute.');
          }

          observer.disconnect();
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
